import Fetch, { pageInfo } from './fetch';
import Qs from 'qs'

const systemConfigRequest = {
    /**
     * 展示表格
     * */
    getHolidaysByMonth(month, shcoolId) {
        return Fetch({
            url: '/holidaysFestivals/getHolidaysByMonth?month=' + month + '&shcoolId=' + shcoolId,
            method: 'get',
            // data:
            // headers: { 'Content-Type': 'application/x-www-form-urlencoded'}
        });
    },
    delUser(id) {
        return Fetch({
            url: '/ucAccount/delUser?id=' + id,
            method: 'post'
        });
    },
    getCheckInRuleBySchoolId(shcoolId) {
        return Fetch({
            url: '/checkInRule/getCheckInRuleBySchoolId?shcoolId=' + shcoolId,
            method: 'get',
            // data:
            // headers: { 'Content-Type': 'application/x-www-form-urlencoded'}
        });
    },
    queryUserInfo(str) {
        return Fetch({
            url: '/ucAccount/queryUserInfo?' + str,
            method: 'get',
            // data:
            // headers: { 'Content-Type': 'application/x-www-form-urlencoded'}
        });
    },
    querySchoolSysRoles() {
        return Fetch({
            url: '/school/querySchoolSysRoles',
            method: 'get',
            // data:
            // headers: { 'Content-Type': 'application/x-www-form-urlencoded'}
        });
    },

    deleteCheckInRule(ruleId) {
        return Fetch({
            url: '/checkInRule/deleteCheckInRule?ruleId=' + ruleId,
            method: 'get',
            // data:
            // headers: { 'Content-Type': 'application/x-www-form-urlencoded'}
        });
    },
    getStudentListByIds(key) {
        return Fetch({
            url: '/student/getStudentListByIds?ids=' + key,
            method: 'get',
            // data:
            // headers: { 'Content-Type': 'application/x-www-form-urlencoded'}
        });
    },
    getStudentByKey(key, page, size) {
        return Fetch({
            url: '/student/getStudentByKey?' + key + pageInfo(page, size),
            method: 'get',
            // data:
            // headers: { 'Content-Type': 'application/x-www-form-urlencoded'}
        });
    },
    setHoliday(list) {
        return Fetch({
            url: '/holidaysFestivals/setHoliday',
            method: 'post',
            data: list
            // data:
            // headers: { 'Content-Type': 'application/x-www-form-urlencoded'}
        });
    },
    queryUnK12StuList(schoolId, page, size) {
        return Fetch({
            url: '/ucStudent/queryUnK12StuList?schoolId=' + schoolId + pageInfo(page, size),
            method: 'get',
            // data:
            // headers: { 'Content-Type': 'application/x-www-form-urlencoded'}
        });
    },

    updPWD(param) {
        return Fetch({
            url: '/ucAccount/updPWD',
            method: 'post',
            data: Qs.stringify(param),
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        });
    },
    /**
     * 新增校区
     * */
    addSchoolCampus(param) {
        return Fetch({
            url: '/school/addSchoolCampus',
            method: 'post',
            data: Qs.stringify(param),
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        });
    },
    /**
     * 编辑校区
     * */
    updateSchoolCampus(param) {
        return Fetch({
            url: '/school/updateSchoolCampus',
            method: 'post',
            data: Qs.stringify(param),
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        });
    },
    /**
     * 删除校区
     * */
    deleteSchoolCampus(param) {
        return Fetch({
            url: '/school/deleteSchoolCampus',
            method: 'post',
            data: Qs.stringify(param),
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        });
    },
    /**
     * 查询学院、年级等基础接口
     * */
    querySchoolBaseInfo(id) {
        return Fetch({
            url: '/basic/querySchoolBaseInfo?schoolId=' + id,
            method: 'get'
        });
    },
    /**
     * 查询学院、年级等基础接口
     * */
    getImportStatus(key, value) {
        return Fetch({
            url: '/exportData/getImportStatus?key=' + key + '&value=' + value,
            method: 'get'
        });
    },
    /**
     * 根据参数查班级
     * */
    queryUnK12ClassByParams(param) {
        return Fetch({
            url: '/classs/queryUnK12ClassByParams?' + Qs.stringify(param),
            method: 'get'
        });
    },
    /**
     * 根据教师查班级
     * */
    qryMasterClasses(param) {
        return Fetch({
            url: '/classs/qryMasterClasses?wcyc_token=' + param,
            method: 'get'
        });
    },
    /**
     * 根据学校查学院
     * */
    querySchoolCollege(id) {
        return Fetch({
            url: '/school/querySchoolCollege?schoolId=' + id,
            method: 'get'
        });
    },

    /**
     * 根据学校查校区
     * */
    querySchoolCapmus(id) {
        return Fetch({
            url: '/school/querySchoolCapmus?schoolId=' + id,
            method: 'get'
        });
    },
    /**
     * 新增学院
     * */
    addAcademy(param) {
        return Fetch({
            url: '/school/addAcademy',
            method: 'post',
            data: Qs.stringify(param),
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }

        });
    },
    /**
     * 修改学院
     * */
    updateAcademy(param) {
        return Fetch({
            url: '/school/updateAcademy',
            method: 'post',
            data: Qs.stringify(param),
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        });
    },
    /**
     * 删除
     * */
    deleteCollege(param) {
        return Fetch({
            url: '/school/deleteCollege',
            method: 'post',
            data: Qs.stringify(param),
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        });
    },
    addCheckInRule(param) {
        return Fetch({
            url: '/checkInRule/addCheckInRule',
            method: 'post',
            data: param
        });
    },
    updateCheckInRule(param) {
        return Fetch({
            url: '/checkInRule/updateCheckInRule',
            method: 'post',
            data: param
        });
    },

    lockStatuUpdate(ruleId, lockStatus) {
        return Fetch({
            url: '/checkInRule/lockStatuUpdate?ruleId=' + ruleId + '&lockStatus=' + lockStatus,
            method: 'get'
        });
    },
    querySchoolHouseTree(schoolId) {
        return Fetch({
            url: '/basic/querySchoolHouseTree?schoolId=' + schoolId,
            method: 'get'
        });
    },
    /**
     * 根据楼栋查楼层
     * */
    getAllFloorDormitory(param) {
        return Fetch({
            url: '/floor/getAllFloorDormitory?' + Qs.stringify(param),
            method: 'get'
        });
    },
    /**
     * 新增楼栋
     * */
    updateBuilding(param) {
        return Fetch({
            url: '/house/updateOne',
            data: param,
            method: 'post'
        });
    },
    /**
     * 编辑楼栋
     * */
    addBuilding(param) {
        return Fetch({
            url: '/house/addOne',
            data: param,
            method: 'post'
        });
    },
    /**
     * 删除楼栋
     * */
    deleteBuilding(param) {
        return Fetch({
            url: '/house/deleteOne',
            data: Qs.stringify(param),
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        });
    },
    /**
     * 查楼栋详情
     * */
    buildingDetail(id) {
        return Fetch({
            url: '/house/selectOne?houseId=' + id,
            method: 'get',
        });
    },
    /**
     * 批量新增床位
     * */
    saveDormitoryList(param) {
        return Fetch({
            url: '/floor/saveDormitoryList',
            data: param,
            method: 'post'
        });
    },
    /**
     * 查楼栋空余床位数量
     * */
    getNoUseBedTotal(id) {
        return Fetch({
            url: '/house/getNoUseBedTotal?houseId=' + id,
            method: 'get',
        });
    },
    /**
     * 查楼栋已使用床位数量
     * */
    getUseCountByHouseId(id) {
        return Fetch({
            url: '/house/getUseCountByHouseId?houseId=' + id,
            method: 'get',
        });
    },
    /**
     * 查宿舍空余床位和入住人数数量
     * */
    qryDormitoryUseAndEmptyCount(id) {
        return Fetch({
            url: '/dormitory/qryDormitoryUseAndEmptyCount?dormitoryId=' + id,
            method: 'get',
        });
    },

    /**
     * 编辑宿舍
     * */
    updateDormitory(param) {
        return Fetch({
            url: '/dormitory/updateOne',
            data: param,
            method: 'post'
        });
    },
    /**
     * 删除宿舍
     * */
    deleteDormitory(param) {
        return Fetch({
            url: '/dormitory/deleteOne',
            data: Qs.stringify(param),
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        });
    },
    /**
     * 导出宿舍
     * */
    exportDormitoryList(param) {
        return Fetch({
            url: '/exportData/exportDormitoryList?' + Qs.stringify(param),
            method: 'get'
        });
    },
    /**
     * 根据校区查楼栋
     * */
    getAllHouseBySchool(param) {
        return Fetch({
            url: '/house/getAllHouseBySchool',
            data: Qs.stringify(param),
            method: 'get'
        });
    },
    /**
     * 新增系
     * */
    addDepartment(param) {
        return Fetch({
            url: '/school/addDepartment',
            data: Qs.stringify(param),
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        });
    },
    /**
     * 编辑系
     * */
    updateDepartment(param) {
        return Fetch({
            url: '/school/updateDepartment',
            data: Qs.stringify(param),
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        });
    },
    /**
     * 删除系
     * */
    deleteDepartment(param) {
        return Fetch({
            url: '/school/deleteDepartment',
            data: Qs.stringify(param),
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        });
    },
    /**
     * 新增年级
     * */
    addGrade(param) {
        return Fetch({
            url: '/grade/addGrade',
            data: Qs.stringify(param),
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        });
    },
    /**
     * 修改年级
     * */
    updateGrade(param) {
        return Fetch({
            url: '/grade/updateGrade',
            data: Qs.stringify(param),
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        });
    },
    /**
     * 删除年级
     * */
    deleteGrade(param) {
        return Fetch({
            url: '/grade/deleteGrade',
            data: Qs.stringify(param),
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        });
    },

    queryAdminById(id) {
        return Fetch({
            url: '/ucAccount/queryAdminById?id=' + id,
            method: 'get'
        });
    },

    /**
     * 升级年级
     * */
    upGradeLv(param) {
        return Fetch({
            url: '/grade/upGradeLv',
            data: Qs.stringify(param),
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        });
    },
    /**
     * 查询年级
     * */
    queryUnK12GreadesByParams(param) {
        return Fetch({
            url: '/grade/queryUnK12GreadesByParams?' + Qs.stringify(param),
            method: 'get'
        });
    },
    /**
     * 批量新增班级
     * */
    addNewClass(param) {
        return Fetch({
            url: '/classs/addNewClass',
            data: Qs.stringify(param),
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        });
    },
    /**
     * 修改班级
     * */
    updateClassInfo(param) {
        return Fetch({
            url: '/classs/updateClassInfo',
            data: Qs.stringify(param),
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        });
    },
    /**
     * 删除班级
     * */
    deleteClass(param) {
        return Fetch({
            url: '/classs/deleteClass',
            data: Qs.stringify(param),
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        });
    },
    /**
     * 导出班级
     * */
    exportClassList(param) {
        return Fetch({
            url: '/exportData/exportClassList?' + Qs.stringify(param),
            method: 'get'
        });
    },
    /**
     * 导入宿舍
     * */
    importHostel(file) {
        return Fetch({
            url: '/importData/importHostel',
            headers: { 'Content-Type': 'application/formData' },
            method: 'post',
            data: file
        });
    },
    /**
     * 导入床位
     * */
    importBed(file) {
        return Fetch({
            url: '/importData/importBed',
            headers: { 'Content-Type': 'application/formData' },
            method: 'post',
            data: file
        });
    },
    queryMasterDetail(id) {
        return Fetch({
            url: '/ucAccount/queryMasterDetail?id=' + id,
            method: 'get'
        });
    },
    /**
     * 导入班级
     * */
    importClass(file) {
        return Fetch({
            url: '/importData/importClass',
            headers: { 'Content-Type': 'application/formData' },
            method: 'post',
            data: file
        });
    },
    updUserStatus(id, status) {
        return Fetch({
            url: '/ucAccount/updUserStatus?id=' + id + '&status=' + status,
            method: 'post'
        });
    },
    querySGMaster(str, page, size) {
        return Fetch({
            url: '/ucAccount/querySGMaster?' + str + pageInfo(page, size),
            method: 'get'
        });
    },

    querySGManager(str, page, size) {
        return Fetch({
            url: '/ucAccount/querySGManager?' + str + pageInfo(page, size),
            method: 'get'
        });
    },
    /**
     * 同步学生信息
     * */
    saveOrUpdateStudent(param) {
        return Fetch({
            url: '/student/saveOrUpdateStudent?' + Qs.stringify(param),
            method: 'get',
        });
    },
    /**
     * 同步UC学生信息
     * */
    sendData(param) {
        return Fetch({
            url: '/ucStudent/sendData?' + Qs.stringify(param),
            method: 'get',
        });
    },
    /**
     * 同步单个学生信息
     * */
    singleSendData(param) {
        return Fetch({
            url: '/ucStudent/singleSendData?' + Qs.stringify(param),
            method: 'get',
        });
    },
    /**
     * 查询学生
     * */
    queryUnK12StuList(param) {
        return Fetch({
            url: '/ucStudent/queryUnK12StuList?' + Qs.stringify(param),
            method: 'get',
        });
    },
    /**
     * 添加学生
     * */
    addUnK12StuInfo(param) {
        return Fetch({
            url: '/ucStudent/addUnK12StuInfo',
            data: param,
            method: 'post',
        });
    },
    /**
     * 修改学生
     * */
    updUnK12StuInfo(param) {
        return Fetch({
            url: '/ucStudent/updUnK12StuInfo',
            data: param,
            method: 'post',
        });
    },
    /**
     * 删除学生
     * */
    deleteUnK12StuInfo(param) {
        return Fetch({
            url: '/ucStudent/deleteUnK12StuInfo',
            data: Qs.stringify(param),
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        });
    },
    /**
     * 批量删除学生
     * */
    batchDeleteStu(param) {
        return Fetch({
            url: '/ucStudent/batchDeleteStudent',
            data: Qs.stringify(param),
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        });
    },
    /**
     * 导出学生
     * */
    exportUnK12StuList(param) {
        return Fetch({
            url: '/exportData/exportUnK12StuList?' + Qs.stringify(param),
            data: param,
            method: 'get'
        });
    },
    /**
     * 导入学生
     * */
    importStudent(file) {
        return Fetch({
            url: '/importData/importStudent',
            headers: { 'Content-Type': 'application/formData' },
            method: 'post',
            data: file
        });
    },
    /**
     * 批量导入学生照片
     * */
    importStudentPic(file) {
        return Fetch({
            url: '/importData/importStudentPic',
            headers: { 'Content-Type': 'application/formData' },
            method: 'post',
            data: file
        });
    },
    queryManagerById(id) {
        return Fetch({
            url: '/ucAccount/queryManagerById?id=' + id,
            method: 'get'
        });
    },
    uploadFile(data) {
        return Fetch({
            url: '/oss/upload',
            method: 'post',
            data: data,
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },
    updUser(form) {
        return Fetch({
            url: '/ucAccount/updUser',
            method: 'post',
            data: form,

        });
    },
    addUser(form) {
        return Fetch({
            url: '/ucAccount/addUser',
            method: 'post',
            data: form,

        });
    },
    resetPWD(id) {
        return Fetch({
            url: '/ucAccount/resetPWD?id=' + id,
            method: 'post',

        });
    },
    batchCheckOut(data) {
        return Fetch({
            url: '/dormitory/batchCheckOut',
            method: 'post',
            data: data

        });
    },
    singleCheckOut(id, dormitoryId) {
        return Fetch({
            url: '/dormitory/singleCheckOut?studentId=' + id + '&dormitoryId=' + dormitoryId,
            method: 'post',

        });
    },
    downloadFailFile(filePath) {
        return Fetch({
            url: '/exportData/downloadFailFile?filePath=' + filePath,
            method: 'get',
            responseType: 'blob',
        });
    },
    exportCheckinList(str, page, size) {
        return Fetch({
            url: '/exportData/exportCheckinList?' + str + pageInfo(page, size),
            method: 'get',
        });
    },
    exportStudentCheckinList(param, page, size) {
        return Fetch({
            url: '/exportData/exportStudentCheckInList?' + Qs.stringify(param) + pageInfo(page, size),
            method: 'get'
        });
    },

    exportContinuityCheckList(param, page, size) {
        return Fetch({
            url: '/exportData/exportContinuityCheckList?' + Qs.stringify(param) + pageInfo(page, size),
            method: 'get'
        });
    },

    // 导出进出宿舍记录
    exportStudentInOutList(param, page, size) {
        return Fetch({
            url: '/exportData/exportStudentInOutList?' + Qs.stringify(param) + pageInfo(page, size),
            method: 'get'
        });
    },
    //=============通道设备api==== statr===========//

    findDeviceList(str) {
        return Fetch({
            url: '/hkvs/device/findDeviceList?' + str,
            method: 'get',
        });
    },

    // GET /hkvs/house/waitAssignList
    waitAssignList() {
        return Fetch({
            url: '/hkvs/house/waitAssignList',
            method: 'get',
        });
    },

    // POST /hkvs/device/updateDevice
    // 更新并拉取设备
    updateDevice() {
        return Fetch({
            url: '/hkvs/device/updateDevice',
            method: 'post',
            headers: { showLoading: false }
        });
    },

    getReportSavingBySchoolId(id) {
        return Fetch({
            url: '/reportSavingInfo/getReportSavingBySchoolId?schoolId=' + id,
            method: 'get',
        });
    },
    updateReportSaving(data) {
        return Fetch({
            url: '/reportSavingInfo/updateReportSaving',
            method: 'post',
            data: data

        });
    },
    // POST /hkvs/device/allotDevice  分配设备
    allotDevice(dto) {
        return Fetch({
            url: '/hkvs/device/allotDevice',
            method: 'post',
            // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data: {
                list: dto
            },
        });
    },
    querySGAdmin(str, page, size) {
        return Fetch({
            url: '/ucAccount/querySGAdmin?' + str + pageInfo(page, size),
            method: 'get'
        });

        //=============通道设备api==== end===========//

    },
    queryHQAdmin(str, page, size) {
        return Fetch({
            url: '/ucAccount/queryHQAdmin?' + str + pageInfo(page, size),
            method: 'get'
        });

    },
    importClassTeacher(file) {

        return Fetch({
            url: '/importData/importClassTeacher',
            headers: { 'Content-Type': 'application/formData' },
            method: 'post',
            data: file
        });

    },
    checkDeleteStatus() {
        return Fetch({
            url: '/ucStudent/checkStatus',
            method: 'get',
            headers: { showLoading: false }
        });
    },
    checkUpStatus() {
        return Fetch({
            url: '/grade/checkUpStatus',
            method: 'get',
            headers: { showLoading: false }
        });
    },
    checkSendData() {
        return Fetch({
            url: '/ucStudent/checkSendData',
            method: 'get',
            headers: { showLoading: false }
        });
    },
    singleDelHKStuInfo(data) {
        return Fetch({
            url: '/ucStudent/singleDelHKStuInfo',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data: Qs.stringify(data)
        });
    },
}

export default systemConfigRequest;



// WEBPACK FOOTER //
// ./src/api/systemConfig.js